import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_PURCHASEORDERTYPES } from "../../../../utils/constants";
import { PurchaseOrderTypeInterface } from "../../../../models/ProcurementModule/PurchateOrder/PurchaseOrderType";
import purchaseOrderTypeService from "../../../../services/procurementService/purchaseOrderTypeService";

interface AddPurchaseOrderTypeContext {
  previousPurchaseOrderTypes: PurchaseOrderTypeInterface[];
}

const useAddPurchaseOrderType = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    PurchaseOrderTypeInterface,
    Error,
    PurchaseOrderTypeInterface,
    AddPurchaseOrderTypeContext
  >({
    mutationFn: purchaseOrderTypeService.Create,

    onMutate: () => {
      const previousPurchaseOrderTypes =
        queryClient.getQueryData<PurchaseOrderTypeInterface[]>([
          CACHE_KEY_PURCHASEORDERTYPES,
          page,
          pageSize,
        ]) || [];

      return { previousPurchaseOrderTypes };
    },

    onSuccess: (savedPurchaseOrderType) => {
      queryClient.setQueryData<PurchaseOrderTypeInterface[]>(
        [CACHE_KEY_PURCHASEORDERTYPES, page, pageSize],
        (purchaseOrderTypes) =>
          purchaseOrderTypes
            ? [savedPurchaseOrderType, ...purchaseOrderTypes]
            : [savedPurchaseOrderType]
      );
    },

    onError: (error, newPurchaseOrderType, context) => {
      if (!context) return;

      queryClient.setQueryData<PurchaseOrderTypeInterface[]>(
        [CACHE_KEY_PURCHASEORDERTYPES, page, pageSize],
        context.previousPurchaseOrderTypes
      );
    },
  });
};

export default useAddPurchaseOrderType;
